<template>
  <div class="marginNormalTop">
    <div class="row paddingSmallBottom flexBox">
      <div class="twelve columns">
        <div
          id="card-number"
          class="form-control hosted-field-input"
        />
      </div>
    </div>
    <div class="row paddingSmallBottom">
      <div class="eight columns">
        <input
          id="billing_address"
          type="text"
          placeholder="Street Address"
          name="billing_address"
          value=""
          required
          @input="updateBillingAddress"
        >
      </div>
      <div class="four columns">
        <div
          id="billing_zip"
          class="form-control hosted-field-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="eight columns">
        <div
          id="expiration-date"
          class="form-control hosted-field-input"
        />
      </div>
      <div class="four columns">
        <div
          id="cvv"
          class="form-control hosted-field-input"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApiResponse from '@/components/ApiResponse'

export default {
  name: 'CreditCardForm',
  components: {
    ApiResponse
  },
  props: [
    'billing_address'
  ],
  methods: {
    updateBillingAddress: function (e) {
      this.$emit('updateBillingAddress', e.target.value)
    }
  }
}
</script>

<style scoped>
</style>
